import { Controller } from "stimulus"

export default class extends Controller {
  static values = { clientSecret: String, publicKey: String }

  async connect() {
    this.stripe = Stripe(this.publicKeyValue)
    const checkout = await this.stripe.initEmbeddedCheckout({ clientSecret: this.clientSecretValue });
    checkout.mount('#checkout');
  }
}
